import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useState, useEffect } from 'react';
import { i18n } from '../../i18n/translate.js';
import { SelectControl } from '../Form/Controls/SelectControl.js';
import { GenericModal } from '../GenericModal/index.js';
import { FloatingLabelFormField } from '../../material/FloatingLabelFormField.js';
import { Layout } from '../../core/components/Layout/component.js';
import { requestExternalData } from '../../utils/ApiUtil.js';
var SchoolModal = function SchoolModal(_ref) {
  var homeroomDomain = _ref.homeroomDomain,
    user = _ref.user,
    showSchoolModal = _ref.showSchoolModal,
    toggleSchoolModal = _ref.toggleSchoolModal;
  var containerRef = useRef(null);
  var schools = user === null || user === void 0 ? void 0 : user.schools;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(user === null || user === void 0 ? void 0 : user.current_school),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSchool = _useState4[0],
    setSelectedSchool = _useState4[1];
  var homeroomToken = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('Homeroom_access_token');
  var switchCurrentSchool = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee(selectedSchool) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (selectedSchool) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.p = 1;
            _context.n = 2;
            return requestExternalData("".concat(homeroomDomain, "/api/v3/me/switch_school/").concat(selectedSchool.id), homeroomToken, false, 'POST', {}, false);
          case 2:
            response = _context.v;
            if (response) {
              window.location.href = '/teacher/explore_courses';
            } else {
              console.error('Failed to switch school');
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('Error switching school:', _t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function switchCurrentSchool(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    isLoading && containerRef && containerRef.current && setLoading(false);
  }, [isLoading]);
  useEffect(function () {
    i18n && i18n.loadTranslations();
  }, []);
  var onCancel = function onCancel() {
    toggleSchoolModal();
  };
  var onSaveSchool = function onSaveSchool() {
    switchCurrentSchool(selectedSchool);
  };
  if (!schools) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(GenericModal, {
    canClose: true,
    modalClass: "school-selection-modal",
    footerCloseButton: {
      id: 'close-schools-modal-button'
    },
    onClose: onCancel,
    saveButtonConfig: {
      disabled: !(schools !== null && schools !== void 0 && schools.length),
      id: 'apply-courses-modal-button',
      saveAction: onSaveSchool,
      saveText: i18n.t('Save'),
      variant: 'primary'
    },
    show: showSchoolModal,
    title: i18n.t('Choose Your School'),
    stickyFooter: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "school-modal-section"
  }, /*#__PURE__*/React.createElement(FloatingLabelFormField, {
    required: true,
    name: "new_school",
    caption: i18n.t('School')
  }, /*#__PURE__*/React.createElement(SelectControl, {
    labelKey: "name",
    valueKey: "id",
    options: schools,
    onChange: function onChange(school) {
      setSelectedSchool(school);
    },
    defaultValue: schools.find(function (school) {
      return school.id === user.current_school.id;
    })
  })))));
};
SchoolModal.displayName = "SchoolModal";
export { SchoolModal };